/**
 * The spinner a lazy route shows while its chunk downloads (App.tsx), and
 * that a translated tool page shows while its copy loads.
 *
 * It keeps the screen's height. Inside the landing shell the footer renders
 * right under it: on the free tool pages free-tool-landing.css cancels
 * `min-h-screen` for the tools' own wrappers, the loader lost its height
 * too, and the footer sat under the header until the tool arrived and pushed
 * it off the screen. That one jump was a 0.48 layout shift on phones;
 * Search Console (Oct 30 2026) rated 1,415 mobile URLs poor for layout shift,
 * group CLS 0.34 (/es/audio-converter) and 0.26 (/zh/pitch-changer). The
 * `route-loader` class is what free-tool-landing.css keeps tall.
 */
export default function RouteLoader() {
  return (
    <div className="route-loader min-h-screen flex items-center justify-center bg-background">
      <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
